var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("The page youʼre looking for canʼt be found")]),_c('div',{staticClass:"text-center"},[_c('v-btn',{on:{"click":_vm.back}},[_vm._v("Back to Lattehub admin")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }